import { createAction } from 'redux-starter-kit';


/**
 * An action creator that puts an inspection damage into the state.
 * @param {object} damage An inspection damage.
 * @example dispatch(putInspectionDamage(damage));
 */
export const putInspectionDamage = createAction('PUT_INSPECTION_DAMAGE');

/**
 * An action creator that adds inspection damages into the state.
 * This will update any duplicates already in the state.
 * @param {object} damages An array of inspection damages.
 * @example dispatch(addInspectionDamages(damages));
 */
export const addInspectionDamages = createAction('ADD_INSPECTION_DAMAGES');
